<template>
    <div class="editorContainer">
        <survey-editor></survey-editor>
    </div>
</template>

<script>
import SurveyEditor from '../components/SurveyEditor'

export default {
    name: 'AdminPage',
    mixins: [],
    data() {
        return {
        }
    },
    components: {
        SurveyEditor
    },
    mounted() {
    }
}
</script>

<style lang="scss">
</style>